import { EventEmitter } from 'fbemitter';

let eventEmitter;

function getEventEmitter() {
  if (!eventEmitter) {
    eventEmitter = new EventEmitter();
  }

  return eventEmitter;
}

function createListener(listenerName, callback) {
  let eventEmitter = getEventEmitter();

  if (eventEmitter.listeners(listenerName).length > 0) {
    console.warn('This listener already has a function assign to it');
    return null;
  }

  return getEventEmitter().addListener(listenerName, callback);
}

function removeListener(listener) {
  if (listener) {
    listener.remove();
  }
}

function emitEvent(listenerName, ...args) {
  return getEventEmitter().emit(listenerName, args);
}

export default {
  createListener: createListener,
  removeListener: removeListener,
  emitEvent: emitEvent
};



// WEBPACK FOOTER //
// ./src/components/modules/event-emitter/EventEmitter.js